import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6cab1f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview-wrap" }

import ApprovalDeployControl from './_components/approval-deploy-control/approval-deploy-control.vue'
import SecurityStatus from './_components/security-status/security-status.vue'
import RealtimeMonitoring from './_components/realtime-monitoring/realtime-monitoring.vue'
import DataSecurityZone from './_components/data-security-zone/data-security-zone.vue'
import OnlineControlZone from './_components/online-control-zone/online-control-zone.vue'
import AssetStatusZone from './_components/asset-status-zone/asset-status-zone.vue'
import LogInformationZone from './_components/log-information-zone/log-information-zone.vue'
import VersionUpgradeNoticeDialog from './_components/version-upgrade-notice-dialog/version-upgrade-notice-dialog.vue'
import LazyComponent from '@/views/dashboard/_components/lazy-component/lazy-component.vue'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export default /*#__PURE__*/_defineComponent({
  __name: 'overview',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(SecurityStatus)
      ]),
      _: 1
    }),
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(ApprovalDeployControl)
      ]),
      _: 1
    }),
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(RealtimeMonitoring)
      ]),
      _: 1
    }),
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(AssetStatusZone)
      ]),
      _: 1
    }),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createBlock(LazyComponent, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(DataSecurityZone)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(OnlineControlZone)
      ]),
      _: 1
    }),
    _createVNode(LazyComponent, null, {
      default: _withCtx(() => [
        _createVNode(LogInformationZone)
      ]),
      _: 1
    }),
    _createVNode(VersionUpgradeNoticeDialog)
  ]))
}
}

})